PLAN_SKU_GIFT_ANNUAL